import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'login',
        loadComponent: () => import('./layout/auth/login/login').then(m => m.Login)
    },
    {
        path: 'forgot-password',
        loadComponent: () => import('./layout/auth/forgot-password/forgot-password').then(m => m.ForgotPassword),
    },
    {
        path: 'register',
        loadComponent: () => import('./layout/auth/registration/registration').then(m => m.Registration)
    },
    {
        path: '',
        loadComponent: () => import('./layout/main/main-layout/main-layout').then(m => m.MainLayout),
        children: [
            {
                path: 'inventory',
                children: [
                    { path: 'home', loadComponent: () => import('./layout/pages/inventory-and-products/inventory/inventory-home/inventory-home').then(m => m.InventoryHome) },
                    { path: 'item-view/:id', loadComponent: () => import('./layout/pages/inventory-and-products/inventory/item-view/item-view').then(m => m.ItemView) },
                    { path: 'stock-update', loadComponent: () => import('./layout/pages/inventory-and-products/inventory/stock-update/stock-update').then(m => m.UpdateStock) },
                    { path: 'stock-transfer', loadComponent: () => import('./layout/pages/inventory-and-products/inventory/stock-transfer/stock-transfer').then(m => m.StockTransfer)},
                    { path: 'action-history', loadComponent: () => import('./layout/pages/inventory-and-products/inventory/invemtory-action-history/invemtory-action-history').then(m => m.InvemtoryActionHistory)}
                ]
            },
            {
                path: 'products',
                children: [
                    { path: '', loadComponent: () => import('./layout/pages/inventory-and-products/product-and-category/product-and-category').then(m => m.ProductAndCategory) },
                    { path: 'product-view/:id', loadComponent: () => import('./layout/pages/inventory-and-products/product-and-category/product-view/product-view').then(m => m.ProductView) },
                    { path: 'category-view/:id', loadComponent: () => import('./layout/pages/inventory-and-products/product-and-category/category-view/category-view').then(m => m.CategoryView)}
                ]
            },
            {
                path: 'grn',
                children: [
                    { path: '', loadComponent: () => import('./layout/pages/inventory-and-products/grn/grn-home/grn-home').then(m => m.GrnHome)},
                    { path: 'record',loadComponent: () => import('./layout/pages/inventory-and-products/grn/grn-record/grn-record').then(m => m.GrnRecord)},
                    { path: 'view/:id',loadComponent: () => import('./layout/pages/inventory-and-products/grn/grn-view/grn-view').then(m => m.GrnView)}
                ]
            },
             {
                path: 'billing',
                children: [
                    { path: '', loadComponent: () => import('./layout/pages/sales-and-billing/billing/billing-home/billing-home').then(m => m.BillingHome)},
                    { path: 'allbills', loadComponent: () => import('./layout/pages/sales-and-billing/billing/billing-allbills/billing-allbills').then(m => m.BillingAllbills)},
                    { path: 'createbills', loadComponent: () => import('./layout/pages/sales-and-billing/billing/billing-createbills/billing-createbills').then(m => m.BillingCreatebills)},
                    { path: 'view/:id', loadComponent: () => import('./layout/pages/sales-and-billing/billing/billing-view/billing-view').then(m => m.BillingView)},
                ]
            },
             {
                path: 'loadUnload',
                children: [
                    { path: '', loadComponent: () => import('./layout/pages/Distribution-and-Operations/load-Unload/load-unload-home/load-unload-home').then(m => m.LoadUnloadHome)},
                    { path: 'repStatus', loadComponent: () => import('./layout/pages/Distribution-and-Operations/load-Unload/rep-status/rep-status').then(m => m.RepStatus)},
                     { path: 'loadUnloadHistory', loadComponent: () => import('./layout/pages/Distribution-and-Operations/load-Unload/load-unload-history/load-unload-history').then(m => m.LoadUnloadHistory)},
                 
                ]
            },
              {
                path: 'freeIssues',
                children: [
                    { path: '', loadComponent: () => import('./layout/pages/sales-and-billing/free-issues/free-issue-home/free-issue-home').then(m => m.FreeIssueHome)},
                    { path: 'productWise/:id', loadComponent: () => import('./layout/pages/sales-and-billing/free-issues/free-issue-product-wise/free-issue-product-wise').then(m => m.FreeIssueProductWise)},
                    { path: 'createfreeIssue', loadComponent: () => import('./layout/pages/sales-and-billing/free-issues/create-free-issue-claim/create-free-issue-claim').then(m => m.CreateFreeIssueClaim)},
                     { path: 'recordList', loadComponent: () => import('./layout/pages/sales-and-billing/free-issues/free-issue-record-list/free-issue-record-list').then(m => m.FreeIssueRecordList)},
                ]
            },
            {
                path: 'priceUpdate',
                children: [
                    { path: '', loadComponent: () => import('./layout/pages/sales-and-billing/price-updates/priceupdate-home/priceupdate-home').then(m => m.PriceupdateHome)},
                   
                ]
            },
             {
                path: 'routes',
                children: [
                   { path: '', loadComponent: () => import('./layout/pages/Distribution-and-Operations/routes/routes-home/routes-home').then(m => m.RoutesHome)},
                   
                ]
            },
             {
                path: 'customers',
                children: [
                   { path: '', loadComponent: () => import('./layout/pages/Distribution-and-Operations/customers/customers-home/customers-home').then(m => m.CustomersHome)},
                   { path: 'customerView/:id', loadComponent: () => import('./layout/pages/Distribution-and-Operations/customers/customer-profile-view/customer-profile-view').then(m => m.CustomerProfileView)},
                   
                ]
            },
             {
                path: 'finance',
                children: [
                   { path: '', loadComponent: () => import('./layout/pages/Payment-and-Finance/finance-management/customer-payments/customer-payments').then(m => m.CustomerPayments)},
                   { path: 'creditSettlement', loadComponent: () => import('./layout/pages/Payment-and-Finance/finance-management/customer-credit-settlement/customer-credit-settlement').then(m => m.CustomerCreditSettlement)},
                   { path: 'chequeList', loadComponent: () => import('./layout/pages/Payment-and-Finance/finance-management/cheque-list/cheque-list').then(m => m.ChequeList)},
                    { path: 'recordGrn', loadComponent: () => import('./layout/pages/Payment-and-Finance/finance-management/record-grn-payout/record-grn-payout').then(m => m.RecordGrnPayout)},
                   
                ]
            },
            {
                path: 'reports',
                children: [
                   { path: '', loadComponent: () => import('./layout/pages/general/reports/reports-home/reports-home').then(m => m.ReportsHome)},
                   { path: 'loadbalanceView/:id', loadComponent: () => import('./layout/pages/general/reports/stock-reports/daily-load-balance-view/daily-load-balance-view').then(m => m.DailyLoadBalanceView)},
                    { path: 'freeIssue/:id', loadComponent: () => import('./layout/pages/general/reports/free-issues/free-issue-view/free-issue-view').then(m => m.FreeIssueView)},
               
                ]
            },
             {
                path: 'dashboard',
                children: [
                   { path: '', loadComponent: () => import('./layout/pages/dashboard/dashboard').then(m => m.Dashboard)},
                 
               
                ]
            },
             {
                path: 'settings',
                children: [
                   { path: '', loadComponent: () => import('./layout/pages/general/settings/settings').then(m => m.Settings)},
                   { path: 'addrole', loadComponent: () => import('./layout/pages/general/settings/roles/add-new-role/add-new-role').then(m => m.AddNewRole)},
                   { path: 'roleview/:id', loadComponent: () => import('./layout/pages/general/settings/roles/role-view/role-view').then(m => m.RoleView)},
                   { path: 'users/new', loadComponent: () => import('./layout/pages/general/settings/users/new-user/new-user').then(m => m.NewUser)},
                    { path: 'userview/:id', loadComponent: () => import('./layout/pages/general/settings/users/user-view/user-view').then(m => m.UserView)},
                ]
            }
            
        ]
    }
];
